// Import all views here
import stepView from './views/step';
import homeView from './views/home';
import pillarView from './views/pillar';
import toolsView from './views/tools';
import interviewView from './views/interview';

export default [stepView, homeView, pillarView, toolsView, interviewView];
